/*******************************************************************************
 * Copyright (c) 2024 Malond Limited. All rights reserved.
 * The source code is the property of Malond Limited.
 * The source code may not be shared with third parties without the express consent of Malond Limited.
 * THE CONTENTS OF THIS PROJECT ARE PROPRIETARY AND CONFIDENTIAL.
 * UNAUTHORIZED COPYING, TRANSFERRING OR REPRODUCTION OF THE CONTENTS OF THIS PROJECT,
 * VIA ANY MEDIUM IS STRICTLY PROHIBITED.
 * The receipt or possession of the source code and/or any parts thereof does not convey or imply
 * any right to use them for any purpose other than the purpose for which they were provided to you.
 * The source code is provided as is.
 * Any changes made to the files must be tracked.
 * Malond Limited does not claim ownership of any changes made to the code.
 ******************************************************************************/

export function getUserFullName(
  lastName?: string,
  firstName?: string,
  patronymic?: string
): string {
  const parts = [lastName, firstName, patronymic].filter(
    (i) => !!i && i.trim() !== ""
  )
  if (parts.length === 0) {
    return "Не указано"
  }
  return parts.join(" ")
}

interface User {
  lastName?: string
  firstName?: string
  patronymicName?: string
}

export function getFullName(obj: User = {}): string {
  return getUserFullName(obj.lastName, obj.firstName, obj.patronymicName)
}

export function generatePassword(len = 12): string {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*"
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const array = new Uint32Array(len)
    crypto.getRandomValues(array)
    let pass = ""
    for (let i = 0; i < len; i++) {
      pass += chars[array[i] % chars.length]
    }
    return pass
  }

  // Fallback for environments without crypto
  let pass = ""
  for (let i = 0; i < len; i++) {
    pass += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return pass
}

export const generateSecurePassword = generatePassword
